import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  Head: {
    VocType: '',
    VocNo: '',
    VocName: '',
    A_VocDt: '',
    A_Loc: '',
    LocName: '',
    Picker: '',
    PickerName: '',
    PickedDate: '',
    Status: '',
    A_PickStartTime: '',
    A_PickEndTime: ''
  },
  DropId:"",
  SummaryObj:{
    loc: "",
    // dateFrom: new Date(
    //   new Date().getFullYear(),
    //   new Date().getMonth(),
    //   new Date().getDate() - 10
    // ),
    dateFrom: new Date(),
    dateTo: new Date(),
    statusVal:'',
    DocNo: "",
    location: "All",
  }
   
};

const SliceWHPicking = createSlice({
  name: "SliceWHPicking",
  initialState: { value: initialState },

  reducers: {
    Head_Set: (state, action) => {
      state.value.Head = action.payload;
    },  
    Detail_Set: (state, action) => {
      state.value.DropId = action.payload;
    }, 
    Set_WHPicking_SummaryObj: (state, action) => {
      state.value.SummaryObj = action.payload;
    }, 
    WHPicking_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const {
  Head_Set,
  WHPicking_Init, 
  Detail_Set,
  Set_WHPicking_SummaryObj,
} = SliceWHPicking.actions;
export default SliceWHPicking.reducer;
